export default __webpack_public_path__ + "static/woman-bathing-55762022bba845b7ba77db371e53036d.jpg";